module.exports = __webpack_public_path__ + "static/media/pin-beach.716a878e.svg";